import * as React from "react";
const Sailboat = ({ title, titleId, desc, descId }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 96 96", "aria-labelledby": titleId, "aria-describedby": descId },
    desc ? React.createElement("desc", { id: descId }, desc) : null,
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("mask", { id: "prefix__a", width: 94, height: 94, x: 1, y: 1, maskUnits: "userSpaceOnUse", style: {
            maskType: "luminance",
        } },
        React.createElement("path", { fill: "#fff", d: "M95 1H1v94h94z" })),
    React.createElement("g", { mask: "url(#prefix__a)" },
        React.createElement("path", { fill: "#ED0000", fillRule: "evenodd", d: "M94.8 59.7 63.6 90.9H32.4L1.2 59.7z", clipRule: "evenodd" }),
        React.createElement("path", { fill: "#CFCFCF", d: "M32.4 5.1 87 59.7H32.4z" }),
        React.createElement("path", { fill: "#3F3F3F", d: "M32.4 36.299 9 59.699h23.4z" }))));
export default Sailboat;
//# sourceMappingURL=Sailboat.js.map